import { Pipe, PipeTransform } from '@angular/core';
import { formatISO } from 'date-fns';

@Pipe({
  name: 'isoDate'
})
export class IsoDatePipe implements PipeTransform {

  transform(date: Date): string {
    if (!date || !(date instanceof Date)) return undefined;
    return formatISO(date, { format: 'extended', representation: 'complete' });
  }

}
